<template>
  <b-modal id="tip-modal" title="Add Tip" ok-title="POST" :ok-disabled="tipAlert" @ok="confirmTip" @cancel="emitPostTip(false)">
    <b-row class="py-2">
      <b-col cols="4">Transaction Number: </b-col>
      <b-col cols="4">{{ transaction_number }}</b-col>
    </b-row>
    <b-row class="py-2">
      <b-col cols="4">Transaction Total: </b-col>
      <b-col cols="4">{{ transaction_amount | toCurrency }}</b-col>
    </b-row>
    <hr>
    <b-row class="pt-2">
      <b-col cols="4">Tip</b-col>
      <b-col cols="2">--OR--</b-col>
      <b-col cols="4">Total Paid</b-col>
    </b-row>
    <b-row class="pt-1">
      <b-col cols="4"><b-form-input type="number" size="lg" v-model="tipAmount" min="0.00" step="any"></b-form-input></b-col>
      <b-col cols="2"></b-col>
      <b-col cols="4"><b-form-input type="number" size="lg" v-model="totalPaidAmount" min="0.00" step="any"></b-form-input></b-col>
    </b-row>
    <b-row>
      <b-col cols="4">Maximum: ${{ maxtip }}</b-col>
      <b-col cols="2"></b-col>
      <b-col cols="4">Maximum: ${{ maxtotal }}</b-col>
    </b-row>
    <b-alert class="ml-0" v-model="tipAlert">Tip exceeds maximum you can charge for this transaction</b-alert>
  </b-modal>
</template>

<script>
export default {
  name: 'TipModal',
  props: ['transaction_amount', 'transaction_number'],
  data () {
    return {
      totalPaidAmount: 0.00,
      setTipAmount: 0.00,
      tipAlert: false
    }
  },

  watch: {
    tipAmount: function() {
      if (this.tipAmount > this.maxtip) {
        this.tipAlert = true;
      } else {
        this.tipAlert = false;
      }
    }
  },

  computed: {
    tipAmount: {
      get: function() {
        if (this.totalPaidAmount > 0) {
          return this.totalPaidAmount - this.transaction_amount;
        } else {
          return this.setTipAmount;
        }
      },
      set: function(newValue) {
        this.totalPaidAmount=0;
        this.setTipAmount = newValue;
      }
    },

    maxtotal: function() {
      return Number(Math.round((this.transaction_amount * 1.25)*100) / 100).toFixed(2);
    },

    maxtip: function() {
      return Number(Math.round((this.maxtotal - this.transaction_amount)*100) / 100).toFixed(2);
    }

  },

  methods: {
    confirmTip() {
      this.$bvModal.msgBoxConfirm('Post tip of $'+this.tipAmount+' for '+this.transaction_number+'($'+this.transaction_amount+')?', {
          title: 'Please Confirm Tip',
          okTitle: 'Confirm',
          cancelTitle: 'Back'
        })
        .then(value => {
          if (value==false) {
            this.$bvModal.show('tip-modal');
          } else if (value==true) {
            this.emitPostTip(true);
          }
        })
        .catch(err => {
          console.log(err);
        })
    },

    emitPostTip(tipentered) {
      this.$bvModal.hide('tip-modal');
      this.$emit('emit-post-tip', this.tipAmount, tipentered);
    },
  },
  mounted() {
    this.$bvModal.show('tip-modal');
  }
}
</script>

<style>
</style>
